import React, { Fragment } from 'react';
import QuickCreateReadingModal from '../QuickCreateReadingModal/QuickCreateReadingModal';
import { isFeatureEnabled } from '../../utils/Helpers';

const QuickLinks = () => {
  return (
    <Fragment>
      <li className='nav-title' style={{ cursor: 'default' }}>
        Quick Links
      </li>
      {isFeatureEnabled('quickAddReading') && <QuickCreateReadingModal />}
    </Fragment>
  );
};

export default QuickLinks;
